import { Box, Stack } from '@mui/material';
import { MobileTabs } from 'lib/mobileDesignSystem';
import React, { useState } from 'react';

import {
  FINANCE_DEFAULT_TAB,
  FINANCE_TAB_ITEMS,
  getTabComponent,
} from './tabConfig';

const FinanceTabsView: React.FC = () => {
  const [activeTab, setActiveTab] = useState(FINANCE_DEFAULT_TAB);
  const TabContent = getTabComponent(activeTab);

  return (
    <Stack
      sx={{
        flex: 1,
        minHeight: '100%',
        py: 3,
      }}
      spacing={3}
    >
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <MobileTabs
          value={activeTab}
          items={FINANCE_TAB_ITEMS}
          onChange={setActiveTab}
        />
      </Box>
      {TabContent != null && <TabContent />}
    </Stack>
  );
};

export default FinanceTabsView;
